module.exports = __webpack_public_path__ + "static/media/Avatar2.22bf0f22.svg";